import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['scrollable', 'indicator']
  static values = {
    scrollAmount: { type: Number, default: 400 }
  }

  connect () {
    this.updateIndicatorVisibility()
    this.scrollableTarget.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  }

  disconnect () {
    this.scrollableTarget.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }

  scroll () {
    this.scrollableTarget.scrollBy({
      left: this.scrollAmountValue,
      behavior: 'smooth'
    })
  }

  handleScroll = () => {
    this.updateIndicatorVisibility()
  }

  handleResize = () => {
    this.updateIndicatorVisibility()
  }

  updateIndicatorVisibility () {
    const container = this.scrollableTarget
    const hasOverflow = container.scrollWidth > container.clientWidth
    const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 5

    this.indicatorTarget.hidden = !hasOverflow || isAtEnd
  }
}
